import { ClipLoader } from "react-spinners";

type Props = {
  color?: string;
};

export const InputLoader = ({ color = "#000" }: Props) => {
  return <ClipLoader color={color} size={20} />;
};
